import { buttonStyles } from "../styles";

const styles = (theme) => ({
  root: {
    ...buttonStyles(theme),
  },
});

export default styles;
